export default __webpack_public_path__ + "static/media/marker-pickup.10d03a1b.svg";